import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/arrow_left_blue.svg'
import _imports_1 from '@/assets/img/heart.svg'
import _imports_2 from '@/assets/img/navbar/experience_on.svg'
import _imports_3 from '@/assets/img/face_error.svg'
import _imports_4 from '@/assets/img/menu_right.svg'
import _imports_5 from '@/assets/img/close_brand_error.svg'
import _imports_6 from '@/assets/img/face_love_blue.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-cb319432")

_pushScopeId("data-v-cb319432")
const _hoisted_1 = { class: "modal full bg_white without_footer" }
const _hoisted_2 = { class: "modal_header" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_5 = { class: "modal_body p-0" }
const _hoisted_6 = {
  key: 0,
  class: "page_padding no_image_container flex_centered column"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  class: "mt-3",
  src: _imports_3
}, null, -1)
const _hoisted_8 = {
  key: 1,
  class: "match_container p-0"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_10 = {
  class: "lottieAnimation",
  ref: "lottieExperience"
}
const _hoisted_11 = { class: "page_padding py-0" }
const _hoisted_12 = { class: "d-flex justify-content-center" }
const _hoisted_13 = { class: "card_container hasOtherMatchCompleted" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "gradientOverlay" }, null, -1)
const _hoisted_15 = { class: "question_bottom_div" }
const _hoisted_16 = { class: "question" }
const _hoisted_17 = { class: "page_padding" }
const _hoisted_18 = { class: "shadowButtonsContainer fev_button" }
const _hoisted_19 = /*#__PURE__*/_createVNode("img", {
  src: _imports_5,
  class: "mb-1"
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("img", {
  src: _imports_6,
  class: "mb-1"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  const _component_localized_text = _resolveComponent("localized-text")
  const _component_header_feven = _resolveComponent("header-feven")
  const _component_chevron_fixed = _resolveComponent("chevron-fixed")
  const _component_person_info = _resolveComponent("person-info")
  const _component_love_face_shadow_bar = _resolveComponent("love-face-shadow-bar")
  const _component_report_question = _resolveComponent("report-question")
  const _component_full_horizontal_scroll = _resolveComponent("full-horizontal-scroll")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_header_feven, null, _createSlots({
        left: _withId(() => [
          _createVNode("img", {
            src: _imports_0,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
          })
        ]),
        _: 2
      }, [
        (!_ctx.isExperience)
          ? {
              name: "center",
              fn: _withId(() => [
                _createVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createVNode(_component_localized_text, {
                    class: "fev_text5 fw_700",
                    localizedKey: "app_SecondChance",
                    text: "Second Chance"
                  })
                ])
              ])
            }
          : {
              name: "center",
              fn: _withId(() => [
                _createVNode("div", { class: "text-center" }, [
                  _createVNode("img", { src: _imports_2 }),
                  _createVNode(_component_localized_text, {
                    class: "fev_text5 fw_700",
                    localizedKey: "app_ConfermaCandidatura",
                    text: "Conferma Candidatura"
                  })
                ])
              ])
            }
      ]), 1024)
    ]),
    _createVNode("div", _hoisted_5, [
      (_ctx.loaded && _ctx.error)
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_localized_text, {
              class: "fev_text3 fw_600 mt-4",
              localizedKey: "app_sembraCheSiSiaVerificatoUnProblema",
              text: "Sembra che si sia verificato un problema!"
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.loaded && !_ctx.error)
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            (_ctx.secondChance.biography)
              ? (_openBlock(), _createBlock(_component_chevron_fixed, {
                  key: 0,
                  vertical: "top",
                  horizontal: "right",
                  class: ["whiteRightBg", {op_5 : !_ctx.secondChance.biography}],
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openDescription()))
                }, {
                  default: _withId(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["class"]))
              : _createCommentVNode("", true),
            (_ctx.secondChance.hasAnyExperience)
              ? (_openBlock(), _createBlock(_component_chevron_fixed, {
                  key: 1,
                  vertical: "top",
                  horizontal: "right",
                  class: ["whiteRightBg", { 'marginTopFromOtherChevronFixed' : _ctx.secondChance.biography }]
                }, {
                  default: _withId(() => [
                    (_ctx.secondChance.biography)
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          class: "invisible_div",
                          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.openDescription()), ["stop","prevent"]))
                        }))
                      : _createCommentVNode("", true),
                    _createVNode("div", {
                      class: "lottieContainer bg_experience",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openExperienceList()))
                    }, [
                      _createVNode("div", _hoisted_10, null, 512)
                    ])
                  ]),
                  _: 1
                }, 8, ["class"]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_11, [
              _createVNode(_component_person_info, {
                name: _ctx.secondChance.personName,
                birthDate: _ctx.secondChance.birthDate,
                distanceMeters: _ctx.secondChance.distanceMeters,
                sexualOrientation: _ctx.secondChance.sexualOrientation
              }, null, 8, ["name", "birthDate", "distanceMeters", "sexualOrientation"]),
              _createVNode("div", _hoisted_12, [
                (_ctx.secondChance.minimumAffinityRate > 0)
                  ? (_openBlock(), _createBlock(_component_love_face_shadow_bar, {
                      key: 0,
                      text: _ctx.affinityRateText
                    }, null, 8, ["text"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_13, [
              _createVNode(_component_full_horizontal_scroll, { class: "px-4 py-0" }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.secondChance.questions, (question, index) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "imageCardContainer bg_blue",
                      key: index,
                      style: 'background-image: url(\'' + (question.noBlurImageUrl ? question.noBlurImageUrl : question.blurredImageUrl) + '\')'
                    }, [
                      _hoisted_14,
                      _createVNode(_component_report_question, {
                        matchIdentifier: _ctx.secondChance.matchIdentifier,
                        questionIndex: index,
                        appUserIdentifier: _ctx.secondChance.appUserIdentifier
                      }, null, 8, ["matchIdentifier", "questionIndex", "appUserIdentifier"]),
                      _createVNode("div", _hoisted_15, [
                        _createVNode("div", _hoisted_16, [
                          _createVNode("span", null, _toDisplayString(question.question), 1)
                        ]),
                        (_ctx.secondChance.affinityRateReachedFromOther)
                          ? (_openBlock(), _createBlock("button", {
                              key: 0,
                              class: "fev_button bg_brand",
                              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.viewQuestionAndAnswers && _ctx.viewQuestionAndAnswers(...args)))
                            }, [
                              _createVNode(_component_localized_text, {
                                class: "fev_text7 fw_700",
                                localizedKey: "app_GuardaRisposte",
                                text: "Guarda risposte"
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ], 4))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _createVNode("div", _hoisted_17, [
              _createVNode("div", _hoisted_18, [
                _createVNode("button", {
                  class: "btn",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.refuseMatch()))
                }, [
                  _hoisted_19,
                  _createVNode(_component_localized_text, {
                    localizedKey: "app_Scarta",
                    text: "Scarta",
                    class: "text-uppercase transparent bg_brand_error bg_on_text"
                  })
                ]),
                _hoisted_20,
                _createVNode("button", {
                  class: "btn",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.createChat()))
                }, [
                  _hoisted_21,
                  _createVNode(_component_localized_text, {
                    localizedKey: "app_crea<br>Affinità",
                    text: "Crea<br /> affinità",
                    class: "text-uppercase"
                  })
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})